//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EmailInformationDisplayItem } from './EmailInformationDisplayItem';
import { ProfileType } from './Enums';

export class UserInfoDisplayItem extends ItemBase {
    FullName: string | null = null;
    Email: EmailInformationDisplayItem | null = null;
    FirstName: string | null = null;
    HasProfilePicture: boolean = false;
    HasMfa: boolean = false;
    ID: string | null = null;
    LastName: string | null = null;
    LastLogin: string | null = null;
    ProfileType: ProfileType = ProfileType.Teacher;
    ProfileHeadshotUrl: string | null = null;
    ProfileThumbnailUrl: string | null = null;
    ProfilePictureUrl: string | null = null;

    constructor(initializer?: Partial<UserInfoDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "UserInfoDisplayItem";
}
